module.exports = __webpack_public_path__ + "static/media/default-logo.ea9f7068.png";